import React, { useState, useEffect } from 'react';
import { StyleSheet, Text } from 'react-native';
import { COLORS, FONTS } from '../constants';

const Today = () => {
    const [currentDate, setCurrentDate] = useState('');

    function getDate() {
        var today = new Date();
        var date = ('0' + (today.getDate())).slice(-2);
        var month = ('0' + (today.getMonth() + 1)).slice(-2)
        var year = today.getFullYear();
        var day = today.toLocaleDateString('pl-PL', { weekday: 'long' });
        setCurrentDate(
            day.toUpperCase() + ', ' + date + '/' + month + '/' + year
        );
    }

    useEffect(() => {
        getDate()
    }, []);

    return (
        <Text style={styles.textStyle}>
            {currentDate}
        </Text>
    );
};

const styles = StyleSheet.create({
    textStyle: {
        ...FONTS.subtitle,
        color: COLORS.secondary,
    },
});

export default Today;